// extracted by mini-css-extract-plugin
export default {"successModal":"SuccessModal_successModal__v6d89","inner":"SuccessModal_inner__ExsN8","text":"SuccessModal_text__gLFPH"};